import { SVGProps } from "react";
import { JSX } from "react/jsx-runtime";

const CheckedBoxIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10967 2.33203C3.42301 2.33203 2.33301 3.48736 2.33301 5.27603V10.7214C2.33301 12.51 3.42301 13.6654 5.10967 13.6654H10.8883C12.5757 13.6654 13.6663 12.51 13.6663 10.7214V5.27603C13.6663 3.48736 12.5757 2.33203 10.889 2.33203H5.10967ZM10.8883 14.6654H5.10967C2.85034 14.6654 1.33301 13.08 1.33301 10.7214V5.27603C1.33301 2.91736 2.85034 1.33203 5.10967 1.33203H10.889C13.1483 1.33203 14.6663 2.91736 14.6663 5.27603V10.7214C14.6663 13.08 13.1483 14.6654 10.8883 14.6654V14.6654Z"
      fill="#011533"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.89924 10.6641C6.72197 10.6641 6.54284 10.5939 6.40733 10.4527L4.20396 8.17309C3.93201 7.89162 3.93201 7.43627 4.20396 7.1548C4.4759 6.87332 4.91583 6.87332 5.18777 7.1548L6.89924 8.92432L10.8122 4.87517C11.0842 4.59369 11.5241 4.59369 11.796 4.87517C12.068 5.15664 12.068 5.61199 11.796 5.89346L7.39115 10.4527C7.25564 10.5939 7.07744 10.6641 6.89924 10.6641Z"
      fill="#EE4360"
    />
  </svg>
);

export default CheckedBoxIcon;
